module.exports = __webpack_public_path__ + "img/annual_fee_standard.a6fd8d87.png";